import { render, staticRenderFns } from "./AlertButton.vue?vue&type=template&id=dc82efa8&scoped=true&"
import script from "./AlertButton.vue?vue&type=script&lang=js&"
export * from "./AlertButton.vue?vue&type=script&lang=js&"
import style0 from "./AlertButton.vue?vue&type=style&index=0&id=dc82efa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc82efa8",
  null
  
)

export default component.exports